enum ModalErrorStates {
	INACTIVE = 0,
	LOADING_ORGANISATION_DETAILS = 1,
	LOADING_ORGANISATION_USERS = 2,
	CREATE_NEW_USER = 3,
	UPDATE_EXISTING_USER = 4,
	TRIGGER_ONBOARDING_FLOW = 5,
	SEARCH_USERS = 6,
	ATTACH_USER_TO_ORGANISATION = 7,
	DELETE_USER = 8,
	DETACH_USER = 9,
	SEARCH_ORGANISATIONS = 10,
	COMBINED_SEARCH_USERS = 11,
	CREATE_DUPLICATE_USER = 12,
	ACT_PROJECT_NOT_FOUND = 13,
	ACT_DASHBOARDS_RETRIEVAL = 14,
	ACT_PROJECT_DETAILS_RETRIEVAL = 15,
	ACT_GRANT_ACCESS_INVALID_DATES = 16,
	ACT_GRANT_ACCESS_SAVE_FAILURE = 17,
	ACT_SKIP_ACCESS_FAILURE = 18,
	ACT_SKIP_ACCESS_PROJECT_INFO_UNAVAILABLE = 19
}

enum ModalConfirmationStates {
	INACTIVE = 0,
	DELETE_USER = 1
}

enum ModalActAccessStates {
	INACTIVE = 0,
	ADD_USERS = 1,
	SELECT_DASHBOARDS = 2,
	SET_ACCESS_PERIODS = 3,
	REVIEW_AND_CONFIRM = 4
}

type ActiveModalActAccessStates = Exclude<ModalActAccessStates, ModalActAccessStates.INACTIVE>;

export { ModalErrorStates, ModalConfirmationStates, ModalActAccessStates, ActiveModalActAccessStates };
